import React, { useEffect, useState } from "react";
import { ContactUs, Container, Info, InfoContact, Menu } from "./styles";
import CustomerTab from "../customertab";
import { useSelector } from "react-redux";
import axios from "axios";
import { API_URL } from "../../../constants";
import { toast } from "react-toastify";
import TransactionsTab from "../transactionstab";
import { numberFormat } from "../../../utils";

interface InsightsTabProp {
  isInsightActive: boolean;
  uuid: string;
}
export default function InsightsTab({ isInsightActive, uuid }: InsightsTabProp) {
  let [menuState, setMenuState] = useState({
    isTransactionActive: false,
    isCustomerActive: true,
  });
  const [customers, setCustomers] = useState([]);
  const businessUuid = useSelector((state: any) => state.auth.uuid);
  const [transactions, setTransactions] = useState([]);
  const [balance, setBalance] = useState({ balance: 0, pending: 0 });
  const [isConfirmed, setisConfirmed] = useState(false);

  const handleTransactionTab = () => {
    setMenuState({
      isTransactionActive: true,
      isCustomerActive: false,
    });
  };
  const handleCustomerTab = () => {
    setMenuState({
      isTransactionActive: false,
      isCustomerActive: true,
    });
  };

  const recordHandler = (uuid: string) => {
    axios
      .get(`${API_URL}/transactions/${uuid}`)
      .then((response) => {
        if (response.status === 200) {
          setTransactions(response.data.data.transactions);
        }
      })
      .catch((error) => {
        // console.log(error)
        toast.error("Connection Failed");
      });
  };

  const getBalance = (uuid: string) => {
    axios
      .get(`${API_URL}/transaction/balance/${uuid}`)
      .then((response) => {
        if (response.status === 200) {
          setBalance(response.data.data);
        }
      })
      .catch((error) => {
        // console.log(error)
        // toast.error("Connection Failed");
      });
  };

  const CustomerRecordHandler = (uuid: string) => {
    axios
      .get(`${API_URL}/transaction/customers/${uuid}`)
      .then((response) => {
        if (response.status === 200) {
          setCustomers(response.data.data.customers);
        }
      })
      .catch((error) => {
        // console.log(error)
        toast.error("Connection Failed");
      });
  };

  useEffect(
    () => {
      CustomerRecordHandler(businessUuid);
      recordHandler(businessUuid);
      getBalance(businessUuid);
    },
    // eslint-disable-next-line
    [businessUuid, isConfirmed]
  );

  return (
    <Container hidden={!isInsightActive}>
      <div hidden={!isInsightActive} className=" md:flex w-full block ">
        <div className=" md:w-[19.5rem] ">
          <Menu>
            <h5 onClick={handleCustomerTab} className={menuState.isCustomerActive ? "active" : ""}>
              Customers
            </h5>
            <div />
            <h5 onClick={handleTransactionTab} className={menuState.isTransactionActive ? "active" : ""}>
              Transactions
            </h5>
          </Menu>
          {menuState.isTransactionActive ? (
            <Info>
              <div>
                <table className="table-auto ">
                  <tbody>
                    <tr>
                      <td className="pr-12 pt-6  ">Received:</td>
                      <td className="pr-12 pt-6  ">{numberFormat(balance?.balance)}</td>
                    </tr>
                    <tr>
                      <td className="pr-12 pt-2   ">Pending:</td>
                      <td className="pr-12 pt-2 ">{numberFormat(balance?.pending)}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Info>
          ) : null}
        </div>
        <div className="w-full">
          <TransactionsTab
            isTransactionActive={menuState.isTransactionActive}
            setisConfirmed={setisConfirmed}
            isConfirmed={isConfirmed}
            balance={balance}
            transactions={transactions}
          />
          <CustomerTab isCustomerActive={menuState.isCustomerActive} customers={customers} />
        </div>
      </div>
      <InfoContact>
        Need help?{" "}
        <ContactUs>
          {" "}
          <a href="https://wa.me/message/MDP76I5CDKCGG1" target="_blank" rel="noopener noreferrer">
            Contact Us
          </a>
        </ContactUs>{" "}
      </InfoContact>
    </Container>
  );
}
